import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigFormScreen } from './ConfigFormScreen';
import { useOgSubscriptionJob, useUpdateOgSubscriptionJob } from '@/api/opengater/useSettings';
/**
 * users `admin: subscription-job` — when the daily charge job (`subscription_charge`)
 * runs. Read once at service start; must stay earlier than the cutoff.
 */
export function OpengaterSubscriptionJob() {
    const q = useOgSubscriptionJob();
    const upd = useUpdateOgSubscriptionJob();
    return (_jsx(ConfigFormScreen, { title: "\u0412\u0440\u0435\u043C\u044F \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F", subtitle: "\u0412\u043E \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C \u0441\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438", capability: "subscription-job.write", notice: "\u041F\u043E\u0441\u043B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0441\u0435\u0440\u0432\u0438\u0441 Users. \u0414\u043E \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u0431\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043F\u0440\u0435\u0436\u043D\u0435\u0435 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435.", sections: [
            {
                title: 'Ежедневно в',
                fields: [
                    {
                        key: 'job_hour',
                        label: 'Час',
                        kind: 'int',
                        min: 0,
                        max: 23,
                        hint: 'Раньше конца оплаченного дня.',
                    },
                    { key: 'job_minute', label: 'Минута', kind: 'int', min: 0, max: 59 },
                ],
            },
        ], data: q.data, isLoading: q.isLoading, error: q.error, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
